exports = module.exports = require("../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".sectionItem[data-v-3ea24499]{margin:30px 0}", ""]);

